import { Subject } from 'rxjs';

const subject = new Subject();
export const authService = {
    setUserId: userId => subject.next({ userId: userId }),
    getUserId: () => subject.asObservable()
};
